<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-envelope-open-text"></i> {{ "TITLE.CONTENT" | translate }}</h4>
    <label class="float-right {{isNotification() ? '' : 'custom-div-hidden'}}">
      <a class="mr-2 ml-2 font-styles" href="javascript:"
         (click)="viewParams()"><i class="fa fa-eye"></i> {{ "BUTTON.VIEW-PARAMETERS" | translate }}</a>
    </label>
  </div>
  <div class="modal-body">
    <form [formGroup]="designTenorToNotifyForm">
      <div class="row">
        <label for="subject" class="col-md-3 col-form-label"><b>{{ "LABEL.SUBJECT" | translate }}:</b></label>
        <div class="col-md-9 mb-1">
          <div class="input-group br-6">
            <input type="text"
                   id="subject"
                   class="form-control {{isNotification() ? 'custom-subject1' : ''}}"
                   placeholder="Ingrese asunto"
                   formControlName="subject"
                   [(ngModel)]="tenor.subject">
            <div class="input-group-prepend">
              <div class="br-6">
                <div class="{{isNotification() ? 'custom-subject-default' : 'custom-div-hidden'}} br-6"
                     *ngIf="isNotification()">
                  <input type="text"
                         id="subject1"
                         class="form-control mxw-130 {{isNotification() ? 'custom-subject-default1' : ''}}"
                         placeholder="{{ 'MESSAGE.BUSINESS-NAME' | translate }}"
                         formControlName="subject1">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="subject" class="col-md-3 col-form-label"><b>{{ "LABEL.NOTIFICATION-CONTENT" | translate }}
          :</b></label>
        <div class="col-md-9">
          <quill-editor [styles]="{height: '200px'}"
                        [(ngModel)]="tenor.body"
                        formControlName="body">
          </quill-editor>
          <textarea type="text" class="form-control {{isNotification() ? 'custom-body-default' : 'custom-div-hidden'}}"
                    id="body"
                    [(ngModel)]="body"
                    *ngIf="isNotification()"
                    formControlName="textarea"
                    [rows]="4"></textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()">
      <i class="fa fa-times-circle"></i>  {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
